import { render, staticRenderFns } from "./laboratoryConfig.vue?vue&type=template&id=08a6a9d8&scoped=true"
import script from "./laboratoryConfig.vue?vue&type=script&lang=js"
export * from "./laboratoryConfig.vue?vue&type=script&lang=js"
import style0 from "./laboratoryConfig.vue?vue&type=style&index=0&id=08a6a9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6a9d8",
  null
  
)

export default component.exports